import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ProductIndividualsState, UnitOverviewState } from './Types';

const initialState: UnitOverviewState = {
	unitId: 0,
	unitPublicId: '',
	productIndividuals: {},
};

export const unitOverviewSlice = createSlice({
	name: 'unitOverview',
	initialState,
	reducers: {
		unitIdChanged: (
			state,
			{ payload }: PayloadAction<{ id: number; publicId: string }>
		) => {
			if (!isNaN(payload.id) && payload.id >= 0) {
				// reset state
				return {
					...initialState,
					unitId: payload.id,
					unitPublicId: payload.publicId,
				};
			}

			return state;
		},
		setProductIndividualsCommentsCount: (
			state,
			{ payload }: PayloadAction<ProductIndividualsState>
		) => {
			state.productIndividuals = {
				...payload,

				...state.productIndividuals,
			};
			return state;
		},
		increaseProductIndividualsCommentsCount: (
			state,
			{ payload }: PayloadAction<number>
		) => {
			const commentsCounts =
				state.productIndividuals[payload]?.commentsCount;

			if (commentsCounts >= 0) {
				state.productIndividuals[payload].commentsCount =
					commentsCounts + 1;
			}
			return state;
		},
	},
});

export const {
	increaseProductIndividualsCommentsCount,
	setProductIndividualsCommentsCount,
	unitIdChanged,
} = unitOverviewSlice.actions;

export default unitOverviewSlice.reducer;
